/**
 * Pledge counter block: one-click pledge per visitor, shared count via REST API.
 */

function animateCount(el, from, to) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || from === to) {
    el.textContent = to.toLocaleString("en-US");
    return;
  }

  const duration = 600;
  const start = performance.now();
  el.setAttribute("data-pledge-updating", "");

  const tick = (now) => {
    const t = Math.min((now - start) / duration, 1);
    const eased = 1 - (1 - t) ** 3;
    const cur = Math.round(from + (to - from) * eased);
    el.textContent = cur.toLocaleString("en-US");
    if (t < 1) {
      requestAnimationFrame(tick);
      return;
    }
    el.removeAttribute("data-pledge-updating");
  };

  requestAnimationFrame(tick);
}

function applyPledgedState(block, pledgedText) {
  const btn = block.querySelector("[data-pledge-btn]");
  if (!btn) return;
  btn.textContent = pledgedText;
  btn.disabled = true;
  btn.setAttribute("data-pledged", "");
  btn.setAttribute("aria-label", pledgedText);
}

async function handlePledge(block, counterKey, pledgedText, countEl, currentCount) {
  const btn = block.querySelector("[data-pledge-btn]");
  if (!btn) return;

  const storageKey = "pulp_pledged_" + counterKey;

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = "\u2026"; // ellipsis while loading

  try {
    const res = await fetch(window.pulpPledge.endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": window.pulpPledge.nonce,
      },
      body: JSON.stringify({ counter_key: counterKey }),
    });

    if (!res.ok) {
      throw new Error("HTTP " + res.status);
    }

    const data = await res.json();
    const newCount = Number(data.count);

    localStorage.setItem(storageKey, "1");
    animateCount(countEl, currentCount, newCount);
    block.dataset.initialCount = String(newCount);
    applyPledgedState(block, pledgedText);
  } catch {
    btn.textContent = originalText;
    btn.disabled = false;
  }
}

async function handleShare(block, shareConfirm) {
  const url = window.location.href;
  const title = document.title;

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
    } catch {
      // user cancelled — not an error
    }
    return;
  }

  // clipboard fallback
  try {
    await navigator.clipboard.writeText(url);
  } catch {
    // clipboard unavailable — silent fail
    return;
  }

  shareConfirm.hidden = false;
  setTimeout(() => {
    shareConfirm.hidden = true;
  }, 2500);
}

function initPledgeCounter(block) {
  const counterKey = block.dataset.counterKey;
  if (!counterKey) return;

  const countEl = block.querySelector("[data-pledge-count]");
  if (!countEl) return;

  const pledgedText = block.dataset.pledgedText || "Thank you for pledging!";
  const storageKey = "pulp_pledged_" + counterKey;
  const alreadyPledged = localStorage.getItem(storageKey) === "1";

  if (alreadyPledged) {
    applyPledgedState(block, pledgedText);
  } else {
    const btn = block.querySelector("[data-pledge-btn]");
    if (btn) {
      btn.addEventListener("click", () => {
        const currentCount = parseInt(block.dataset.initialCount, 10) || 0;
        handlePledge(block, counterKey, pledgedText, countEl, currentCount);
      }, { once: true });
    }
  }

  const shareBtn = block.querySelector("[data-share-btn]");
  const shareConfirm = block.querySelector("[data-share-confirm]");
  if (shareBtn && shareConfirm) {
    shareBtn.addEventListener("click", () => handleShare(block, shareConfirm));
  }
}

document.querySelectorAll("[data-pledge-counter]").forEach(initPledgeCounter);
